import React, { Component } from 'react';
import Flight from './Flight'

class FlightsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filterDirectOnly: false,
      sortBy: 'duration', // 'duration', 'price', 'departure'
      maxStops: null
    };
  }

  handleFilterChange = (filterType, value) => {
    this.setState({
      [filterType]: value
    });
  }

  filterAndSortFlights = (flights) => {
    let filtered = [...flights];

    // Filter: Direct flights only
    if (this.state.filterDirectOnly) {
      filtered = filtered.filter(flight => flight.route.length === 1);
    }

    // Filter: Max stops
    if (this.state.maxStops !== null) {
      filtered = filtered.filter(flight => (flight.route.length - 1) <= this.state.maxStops);
    }

    // Sort
    switch(this.state.sortBy) {
      case 'duration':
        filtered.sort((a, b) => a.duration.total - b.duration.total);
        break;
      case 'price':
        filtered.sort((a, b) => a.price - b.price);
        break;
      case 'departure':
        filtered.sort((a, b) => new Date(a.local_departure) - new Date(b.local_departure));
        break;
      default:
        break;
    }

    return filtered;
  }

  render() {
    //console.log("[FlightsList.js] flightData")
    //console.log(this.props.flightData)
    if (this.props.flightData !== null && this.props.flightData !== undefined && this.props.flightData.length !== 0) {
      const data = this.filterAndSortFlights(this.props.flightData);
      const flightsCount = data.length;
      const totalCount = this.props.flightData.length;
      //console.log("[FlightsList.js] data")
      //console.log(data)
      const flights_html = data.map(
        (name, index) => {
          return <Flight key={index} data={name} />
        });
      return(
        <div className="container mt-4">
          <div className="row justify-content-center">
            <div className="col-sm-12 col-lg-10">
              <div className="alert alert-primary alert-dismissible fade show mb-3" role="alert">
                <p className="mb-0">Choose your flight below. The selected flight's details will be imprinted on your ticket.</p>
              </div>
              
              {/* Filters and Sort */}
              <div className="card mb-3">
                <div className="card-body">
                  <div className="row g-3 align-items-end">
                    <div className="col-12 col-md-4">
                      <label className="form-label small">Filter:</label>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="filterDirect"
                          checked={this.state.filterDirectOnly}
                          onChange={(e) => this.handleFilterChange('filterDirectOnly', e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="filterDirect">
                          Direct flights only
                        </label>
                      </div>
                    </div>
                    <div className="col-12 col-md-4">
                      <label className="form-label small">Max Stops:</label>
                      <select
                        className="form-select form-select-sm"
                        value={this.state.maxStops === null ? '' : this.state.maxStops}
                        onChange={(e) => this.handleFilterChange('maxStops', e.target.value === '' ? null : parseInt(e.target.value))}
                      >
                        <option value="">Any</option>
                        <option value="0">0 (Direct)</option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3+</option>
                      </select>
                    </div>
                    <div className="col-12 col-md-4">
                      <label className="form-label small">Sort by:</label>
                      <select
                        className="form-select form-select-sm"
                        value={this.state.sortBy}
                        onChange={(e) => this.handleFilterChange('sortBy', e.target.value)}
                      >
                        <option value="duration">Duration</option>
                        <option value="price">Price</option>
                        <option value="departure">Departure Time</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center mb-2">
                <small className="text-muted">
                  Showing {flightsCount} of {totalCount} {totalCount === 1 ? 'flight' : 'flights'}
                </small>
              </div>
              <div className="table-responsive">
                <table className="table table-hover">
                  <caption className="sr-only">Available flights</caption>
                  <tbody>
                    {flights_html}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      );
    } else if (this.props.flightData !== null && this.props.flightData !== undefined && this.props.flightData.length === 0) {
        return(
          <div className="container mt-2">
            <div className="row justify-content-center">
              <div className="alert alert-warning" role="alert">
              <h6>Sorry, no flights were found.</h6>
              <p><strong>Please try another date or destination!</strong><br/>
              <strong>Make sure you choose a valid destination from the dropdown menu!</strong></p>
              <p className="mb-0 mt-2">
                <strong>Tips:</strong>
                <ul className="mb-0 mt-2">
                  <li>Try dates 30-90 days in the future for better availability</li>
                  <li>Popular routes like Bangkok → Singapore usually have more options</li>
                  <li>Check different departure airports if available</li>
                </ul>
              </p>
              </div>
            </div>
          </div>
        );
    } else {
      if (this.props.loadingFlights) {
        return (
          <div className="container my-5" aria-live="polite">
            <div className="row justify-content-center">
              <div className="col-12 text-center">
                {/* Skeleton Loader */}
                <div className="d-flex align-items-center justify-content-center mb-4">
                  <div className="spinner-border text-primary me-3" role="status" aria-hidden="true"></div>
                  <span className="fs-5">Searching flights…</span>
                </div>
                {/* Skeleton cards */}
                <div className="row justify-content-center">
                  <div className="col-12 col-lg-10">
                    {[1, 2, 3].map(i => (
                      <div key={i} className="card mb-3">
                        <div className="card-body">
                          <div className="row">
                            <div className="col-2">
                              <div className="skeleton-loader" style={{height: '40px', width: '40px', borderRadius: '4px', backgroundColor: '#e0e0e0'}}></div>
                            </div>
                            <div className="col-10">
                              <div className="skeleton-loader mb-2" style={{height: '20px', width: '60%', backgroundColor: '#e0e0e0', borderRadius: '4px'}}></div>
                              <div className="skeleton-loader" style={{height: '16px', width: '40%', backgroundColor: '#e0e0e0', borderRadius: '4px'}}></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      }
      else if (!this.props.firstSearchDone) {
        return (
          <div className="container mt-2">
            <div className="row justify-content-center">
              <div className="alert alert-secondary" role="alert">
                <p><strong>Fill in the form above and receive your ticket in just 30 seconds.</strong></p>
              </div>
            </div>
          </div>
        )
      }
      else {
        return (
          <div className="container">
            <div className="row justify-content-center">
              <p>No Flights found.</p>
            </div>
          </div>
        );
    }
    }
  }
}

export default FlightsList
